import React from 'react';
import '../styles/metric.css';

const Metric = ({ number, description, type, bottom }) =>
  <div>
    <div className={`metric ${type ? `metric--${type}` : ''}`}>
      <div className="metric__number">
        {number}
      </div>
      <div className="metric__description">
        {description}
      </div>
    </div>
    <div className="metric__global">
      {bottom}
    </div>
  </div>;

export default Metric;
